export default __webpack_public_path__ + "static/media/edit.165b9c0a.png";